module.exports = __webpack_public_path__ + "static/media/Graphic-serviceIcon.2a224551.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon/Graphic-serviceIcon.png
// module id = 1679
// module chunks = 0